import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOppervlakte = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M30 10H10v20h20z"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M10 27a3 3 0 1 1 0 6 3 3 0 0 1 0-6m20 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6M10 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6m20 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOppervlakte);

export default ForwardRef;
